import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useState } from 'react';
import { bool, func, number } from 'prop-types';
import { useToasts } from '@magento/peregrine';
import { Check, AlertCircle } from 'react-feather';
import Icon from '@magento/venia-ui/lib/components/Icon';
import { useIntl } from 'react-intl';
import defaultClasses from '@magento/venia-ui/lib/components/Wishlist/WishlistDialog/WishlistLineItem/wishlistLineItem.module.css';
import { useMergeCssClasses } from 'src/Utils/utils';
import { CustomCheckbox } from 'src/components'; // import useWishlistCustomHook from '../../../../../../talons/WishlistCustom/useWishlistCustomHook';

import { generateUrl } from '@magento/peregrine/lib/util/imageUtils';
var THUMB_WIDTH = 60;
var CheckIcon = React.createElement(Icon, {
  size: 20,
  alt: "Success icon",
  src: Check
});
var ErrorIcon = React.createElement(Icon, {
  size: 20,
  alt: "Error icon",
  src: AlertCircle
});

var WishlistLineItem = function WishlistLineItem(props) {
  var id = props.id,
      onClick = props.onClick,
      children = props.children,
      wishlist = props.wishlist,
      checked = props.checked,
      refetchWishlist = props.refetchWishlist,
      isDisabled = props.isDisabled,
      myFavoritesId = props.myFavoritesId,
      removeProductFromWishlist = props.removeProductFromWishlist,
      removingProduct = props.removingProduct,
      _props$setProject = props.setProject,
      setProject = _props$setProject === void 0 ? function () {} : _props$setProject,
      itemWishlistId = props.itemWishlistId,
      refetchFavorites = props.refetchFavorites;
  var classes = useMergeCssClasses(defaultClasses, props.classes);
  var handleClick = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (checked) {
              _context.next = 11;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return onClick(id);

          case 4:
            setProject(children);
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

          case 9:
            _context.next = 18;
            break;

          case 11:
            _context.prev = 11;
            _context.next = 14;
            return removeProductFromWishlist({
              message: "Item has been successfully removed from ".concat(children === 'Favorites' ? 'My Favorites' : children),
              input: {
                wishlistId: id ? Number(wishlist === null || wishlist === void 0 ? void 0 : wishlist.id) : myFavoritesId,
                wishlistItemsId: [+itemWishlistId]
              }
            });

          case 14:
            _context.next = 18;
            break;

          case 16:
            _context.prev = 16;
            _context.t1 = _context["catch"](11);

          case 18:
            refetchFavorites();

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7], [11, 16]]);
  })), [checked, myFavoritesId, children, refetchFavorites]);
  var isCheckboxDisable = isDisabled || removingProduct;
  var wishlistCount = (wishlist === null || wishlist === void 0 ? void 0 : wishlist.items_count) || 0;
  return React.createElement("div", {
    className: "flex justify-between items-center mb-8"
  }, React.createElement("div", {
    className: "".concat(classes['left-part'], " flex items-center")
  }, React.createElement("div", {
    className: 'flex flex-col ml-5'
  }, React.createElement("p", {
    className: "font-bold mb-3"
  }, children === 'Favorites' ? 'My Favorites' : children), React.createElement("span", null, "".concat(wishlistCount, " item").concat(wishlistCount !== 1 ? 's' : ''))), React.createElement("div", null)), React.createElement(CustomCheckbox, {
    checked: checked,
    isCheckboxDisable: isCheckboxDisable,
    onClick: handleClick
  }));
};

export default WishlistLineItem;
WishlistLineItem.defaultProps = {
  id: number,
  isDisabled: bool,
  onClick: func.isRequired
};